import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import utils from 'helpers/utils'
import AuthTemplate from 'components/templates/AuthTemplate'
import { LinearProgress } from '@mui/material'
import queryString from 'query-string'
import useShowError from 'hooks/useShowError'
import images from 'assets/images'
import axios from 'providers/axios'
import useEffectOnce from 'hooks/useEffectOnce'
import { SlackStateObject } from 'helpers/integrations/slack'

const AuthSlack = () => {
  const showError = useShowError()
  const [message, setMessage] = React.useState('Loading...')
  const [loading, setLoading] = React.useState(true)
  const navigate = useNavigate()
  const location = useLocation()
  const parsed = queryString.parse(location.search)

  useEffectOnce(() => {
    if (!parsed.code || !parsed.state) throw new Error('No code or state')

    const stateObject: SlackStateObject = JSON.parse(parsed.state as string)
    const isChromeExtension = stateObject.requester === 'chrome-extension'

    const login = async () => {
      try {
        const { data } = await axios.post('/slack/login', {
          code: parsed.code,
          slackRedirectUri: stateObject.redirect_uri,
          redirectUrl: stateObject.next,
          authDevice: utils.getFullAuthDeviceData(),
        })
        if (!data) throw new Error('No data')
        const { authDevice } = data
        utils.setChromeExtension(authDevice.deviceToken)
        setMessage('Success!')

        if (isChromeExtension) return

        window.location.href = data.redirectUrl
      } catch (error) {
        showError(error)
        navigate('/login')
      } finally {
        setLoading(false)
      }
    }

    const signUp = async () => {
      try {
        const { data } = await axios.post('/slack/sign-up', {
          code: parsed.code,
          slackRedirectUri: stateObject.redirect_uri,
          authDevice: utils.getFullAuthDeviceData(),
          productId: stateObject.productId,
          overrideDefaultSignupAction: stateObject.overrideDefaultSignupAction,
        })
        if (!data) throw new Error('No data')
        const { authDevice } = data
        utils.setChromeExtension(authDevice.deviceToken)
        setMessage('Success!')

        if (isChromeExtension) return

        window.location.href = stateObject.next
      } catch (error) {
        showError(error)
        navigate('/signup')
      } finally {
        setLoading(false)
      }
    }

    if (stateObject.action === 'LOGIN') login()
    if (stateObject.action === 'SIGNUP') signUp()
  })

  return (
    <AuthTemplate>
      <div className="tac">
        <img alt="Slack logo" style={{ width: '40%', maxWidth: '250px' }} src={images.SLACK_PAGE_LOGO} />
        {loading && <LinearProgress sx={{ my: '40px', maxWidth: '400px', mx: 'auto' }} />}
        <p>{message}</p>
      </div>
    </AuthTemplate>
  )
}

export default AuthSlack
